import { ISettingsService } from "../typings/typings";
import { User } from "@play/api-typings";
import { Store } from "@ngrx/store";
import { RootState, getUser, getUserPremium, entryAvailable } from "@play/state";
import { filter } from "rxjs/operators";
declare var Drupal: any;

declare const jQuery: any;

export class UserboxController {
    public textLoading: string;
    public esl_section: string;
    public user: User;
    public showMenu = false;
    public premiumDate;
    public handleClick = this.handleBodyClick.bind(this);
    public hostUrl: string;
    public isPlay: boolean;

    public message = {
        title: null,
        count: 0,
        link: null,
    };

    public static $inject = ["$scope", "$rootScope", "$filter", "$location", "SettingsService", "store", "PLAY_URL", "$http"];
    constructor(
        private $scope,
        private $rootScope,
        private $filter,
        private $location,
        private SettingsService: ISettingsService,
        private store: Store<RootState>,
        private PLAY_URL: string,
        private $http,
    ) {
        $scope.$watch(
            "ctrl.message",
            message => {
                if (message.count > 0) {
                    message.title = this.$filter("translate")("userbox:n-messages", { count: message.count });
                    message.link = "/message/show_unread";
                } else {
                    message.title = this.$filter("translate")("userbox:no-messages");
                    message.link = "/message";
                }
            },
            true
        );

        this.updateMessageCount();

        this.$rootScope.$on("onTePrivateMessageCreate", (() => {
            this.$scope.$apply(() => {
                this.updateMessageCount.bind(this)();
            });
        }));

        this.esl_section = this.SettingsService.legacy_content.esl_section;

        this.store.select(getUser).subscribe(user => (this.user = user.entry));

        this.store
            .select(getUserPremium)
            .pipe(
                filter(entryAvailable),
                filter(({ entry: { until } }) => !isNaN(until.getTime())),
                filter(({ entry: { until } }) => new Date() < until)
            )
            .subscribe(premium => (this.premiumDate = premium.entry.until));

        this.checkUrl();
    }

    private checkUrl() {
        const hostUrl = this.$location.host();

        this.isPlay = hostUrl === this.PLAY_URL;
    }

    private handleBodyClick(e: MouseEvent): void {
        const menuToggle = document.getElementById("userbox__dropdown");

        if (!menuToggle) {
            return;
        }

        const isClickedElementChildOfPopup = menuToggle.contains(e.target as any);

        if (!isClickedElementChildOfPopup) {
            this.toggleMenu();
        }
    }

    public updateMessageCount(): void {
        this.$http.get(Drupal.settings.eslapi_host + "/user/messages").then((count) => {
            this.message.count = Number(count.data);
        });
    }

    public toggleMenu(): void {
        if (this.showMenu) {
            document.body.removeEventListener("click", this.handleClick);
            this.showMenu = false;
        } else if (!this.showMenu) {
            this.showMenu = true;

            setTimeout(() => document.body.addEventListener("click", this.handleClick), 50);
        }
    }
}
